import { entityCreationObject } from "../Data/EntitiyWrappers";
import axiosInstance from "../../../Shared/Utils/axiosInstance";
import { EntityApi } from "../../../Shared/Constants/api";

export const createEntityApi = async (data) => {
  try {
    let response = await axiosInstance.post(
      `${EntityApi}`,
      entityCreationObject(data)
    );

    return response.data;
  } catch (error) {
    return error.response.data;
    // throw error; // Re-throw error for further handling if needed
  }
};
